module.exports = __webpack_public_path__ + "static/media/  (58).77ec3bab.jpg";